import {
    inject,
    observer,
} from 'mobx-react';
import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
    TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import classes from './ratingFacilitiesAreasList.scss';
import {
    CountryStore,
} from '../../mobx-store/stores/countryStore';
import { FacilityStore } from '../../mobx-store/stores/facilitiesStore';
import { FacilityAreaStore } from '../../mobx-store/stores/facilityAreaStore';

interface IProps extends WithSnackbarProps {
    facilityAreaStore: FacilityAreaStore;
    countryStore: CountryStore;
    facilityStore: FacilityStore;
    match: any;
    history: any;
    location: any;
}

interface IState {
    branchId: number;
    areaId: number;
    categoryId: number;
    rating: number;
}

@inject('countryStore')
@inject('facilityAreaStore')
@inject('facilityStore')
@observer
class RatingFacilitiesAreasList extends Component<IProps, IState> {

    branchId: number = -1;
    tableHeader: any = [];
    tableData: any = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string = 'Facility Rating Areas';
    
    constructor(props: IProps) {
        super(props);
    }

    getFacilityTableHeader = () => {
        const headers = [
            {
                title: 'Area',
            },
            {
                title: 'Average Rating',
            },
            {
                title: 'View',
            },
            {
                title: 'Statistics',
            },
            {
                title: 'Export',
            },
        ];

        return headers;
    }

    handleTableButtonCellClicked = (index: number, key: string) => {
        //route to facilities ratings list
        this.props.history.push(`/facilities/reports/branches/${this.branchId}/areas/${this.props.facilityAreaStore.areasRating[index].facilityAreaId}`);
    };

    handleStatisticsCellClicked = (index: number, key: string) => {
        this.props.history.push(`/facilities/reports/branches/${this.branchId}/areas/${this.props.facilityAreaStore.areasRating[index].facilityAreaId}/statistics`);
    }

    handleTableButtonExportClicked = async (index: number) => {
        await this.props.facilityStore.exportAreaFacilitiesRatings(
            this.branchId,
            this.props.facilityAreaStore.areasRating[index].facilityAreaId,
            this.props.facilityAreaStore.areasRating[index].title,
        );
    };

    getTableData = () => this.props.facilityAreaStore.areasRating
    .map((area) => ({
        ...area,
        facilitiesRating: area.facilitiesRating.toFixed(1),
        view: 'View Facilities',
        statistics: 'Statistics',
        export: 'Export Ratings',
    }));

    getRatingFacilityTableCellTypes = (): TableCellTypes[] => {
        const cellTypes: TableCellTypes[] = [
            {
                cellType: 'Text',
                key: 'title',
            },
            {
                cellType: 'Text',
                key: 'facilitiesRating',
            },
            {
                cellType: 'Button',
                key: 'view',
                onClick: this.handleTableButtonCellClicked,
            },
            {
                cellType: 'Button',
                key: 'statistics',
                onClick: this.handleStatisticsCellClicked,
            },
            {
                cellType: 'Button',
                key: 'export',
                onClick: this.handleTableButtonExportClicked,
            },
        ];

        return cellTypes;
    }

    initTable = () => {
        this.tableHeader = this.getFacilityTableHeader();
        this.tableCellTypes = this.getRatingFacilityTableCellTypes();        
        this.tableData = this.getTableData();
    };

    componentWillUnmount() {
        this.props.facilityAreaStore.areasRating = [];
    }

    render() {
        this.initTable();

        return (
            <div className={classes.container}>
                <GeneralTableComponent
                    emptyMessage={'No Areas Ratings'}
                    title={this.title}
                    tableHeader={this.tableHeader}
                    tableData={this.tableData}
                    tableCellTypes={this.tableCellTypes}
                    loadingStatus={[
                        this.props.facilityAreaStore.getFacilitiesAreasRequestStatus,
                        this.props.countryStore.getManagedCountriesRequestStatus
                      ]}
                />
            </div>
        );
    }

    async componentWillMount() {
        const {
            countryStore,
            facilityAreaStore,
            match,
        } = this.props;
        
        await countryStore.getUserManagedCountries();
        this.branchId = match.params.branchId;
        await facilityAreaStore.getAreasRating(this.branchId, countryStore.managedCountries);        
        this.initTable();
    }
}

export default RatingFacilitiesAreasList;
